import { useState } from 'react';
import { IconButton } from '@mui/material';
import { FiFilter } from 'react-icons/fi';
import { useTheme } from 'styled-components';
import { DropDownList, DropDownListProps } from '../DropDownList';

import { Container } from './styles';

interface Props extends DropDownListProps {}

export function DropdownCollaborator({ elementId, ...props }: Props) {
  const theme = useTheme();
  const [displayDropdown, setDisplayDropdown] = useState(false);

  return (
    <Container hasBorder={displayDropdown} id={elementId}>
      {displayDropdown && <DropDownList hasBorder={false} typeReturn="id" {...props} />}
      <IconButton onClick={() => setDisplayDropdown((state) => !state)}>
        <FiFilter size={22} color={theme.colors.primary} />
      </IconButton>
    </Container>
  );
}
